import { Breadcrumb } from "@/components/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/warehouse/features")({
  component: () => (
    <Breadcrumb label="Features" to="/warehouse/features">
      <Outlet />
    </Breadcrumb>
  ),
});
